<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Maththink',
};
</script>

<style scoped lang="scss">
/* font-size: 1rem !important; */
</style>



// WEBPACK FOOTER //
// src/pages/landing-page/index.vue